import type { ComponentStyleConfig } from '@chakra-ui/react';

export const Link: ComponentStyleConfig = {
  baseStyle: {
    transitionDuration: 'normal',
    _hover: {
      color: 'qGray.300',
      textDecoration: 'none',
    },
    whiteSpace: 'nowrap',
  },
  variants: {
    brand: {
      color: 'brand.500',
    },
    hoverBrand: {
      _hover: { color: 'brand.500' },
    },
  },
};
